import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getArticleTypeList, getNewsList, getWebsiteArticleById, getHotList } from "@/services";

export const fetchArticleTypeList = createAsyncThunk("fetchArticleTypeList", async (payload) => {
	const res = await getArticleTypeList(payload);
	return res;
});

export const fetchNewsList = createAsyncThunk("fetchNewsList", async (payload) => {
	const res = await getNewsList(payload);
	return res;
});

export const fetchWebsiteArticleById = createAsyncThunk("fetchWebsiteArticleById", async (payload) => {
	const res = await getWebsiteArticleById(payload);
	return res;
});

export const fetchHotList = createAsyncThunk("fetchHotList", async (payload) => {
	const res = await getHotList(payload);
	return res;
});

const NewsSlice = createSlice({
	name: "news",
	initialState: {},
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(fetchArticleTypeList.rejected, (_, payload) => {
				throw new Error(payload.error.message);
			})
			.addCase(fetchNewsList.rejected, (_, payload) => {
				throw new Error(payload.error.message);
			})
			.addCase(fetchWebsiteArticleById.rejected, (_, payload) => {
				throw new Error(payload.error.message);
			})
			.addCase(fetchHotList.rejected, (_, payload) => {
				throw new Error(payload.error.message);
			});
	},
});

// export const { changeUserInfo } = LoginSlice.actions;

export default NewsSlice.reducer;
